import isEmpty from 'lodash/isEmpty';

function createFieldMaps (widget) {
    this.createCustomFieldMaps(widget);
}

function createCustomFieldMaps (widget) {
    this.customFieldMaps = {};
    widget?.custom_fields.map(item => {
        this.customFieldMaps[item.name] = item;
        return item;
    });
}

function isCustomFieldRequired (name) {
    if (isEmpty(this.customFieldMaps)) {
        return true;
    }
    return this.customFieldMaps[name]?.required;
}

function getCustomField (name) {
    if (isEmpty(this.customFieldMaps)) {
        return null;
    }
    return this.customFieldMaps[name];
}

const setters = {
    createFieldMaps,
    getCustomField,
    createCustomFieldMaps,
    isCustomFieldRequired,
};

export default setters;